<template>
  <div>
    <Header></Header>
    <router-view></router-view>
    <Footer></Footer>
  </div>
</template>
<script>
import Header from "./components/header.vue";
import Footer from "./components/footer.vue";
export default {
  name: "",
  components: {
    Header,
    Footer,
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style scoped  lang="less">
.cancain {
  min-height: 100vh;
  width: 100%;
  background-color: #fff;
}
</style>
